// Banderas de país en SVG (Chrome/Linux no renderiza los emoji 🇨🇴/🇵🇪).
import type { JSX } from "react";

export function CountryFlag({ country, className }: { country: "CO" | "PE"; className?: string }): JSX.Element {
  return (
    <span className={`inline-block shrink-0 overflow-hidden rounded-[2px] ring-1 ring-black/10 ${className ?? "w-5 h-3.5"}`}>
      <svg viewBox="0 0 24 16" className="block w-full h-full" preserveAspectRatio="none" aria-hidden="true">
        {country === "CO" ? (
          <>
            <rect width="24" height="16" fill="#FCD116" />
            <rect y="8" width="24" height="4" fill="#003893" />
            <rect y="12" width="24" height="4" fill="#CE1126" />
          </>
        ) : (
          <>
            <rect width="24" height="16" fill="#ffffff" />
            <rect width="8" height="16" fill="#D91023" />
            <rect x="16" width="8" height="16" fill="#D91023" />
          </>
        )}
      </svg>
    </span>
  );
}
